import React from 'react';
import { FadeIn } from './FadeIn';
export function ClosingContrast() {
  return <section className="py-16 sm:py-24 px-4 bg-hyrox-dark" data-id="element-37">
      <div className="max-w-5xl mx-auto" data-id="element-38">
        <FadeIn data-id="element-39">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-center text-white mb-12" data-id="element-40">
            Una última cosa antes de que decidas.
          </h2>
          <p className="text-xl text-center text-gray-300 mb-12" data-id="element-41">
            La próxima semana vas a estar en alguno de estos dos lugares.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-16" data-id="element-42">
          <FadeIn delay={0.1} data-id="element-43">
            <div className="bg-hyrox-surface border border-red-500/20 p-8 rounded-2xl h-full" data-id="element-44">
              <div className="text-red-400 font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-45">
                El primer lugar
              </div>
              <p className="text-gray-300 leading-relaxed" data-id="element-46">
                Llegás al lunes sin saber exactamente qué hacer. Improvisás la
                sesión sobre la marcha. Tus alumnos entranan pero sin progresión
                real. Sin datos. Sin evidencia. Y la semana siguiente es
                exactamente igual. Con la misma carga mental. Con la misma
                sensación de que algo tiene que cambiar pero sin saber cómo.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-47">
            <div className="bg-hyrox-orange/5 border border-hyrox-orange/30 p-8 rounded-2xl h-full shadow-[0_0_30px_rgba(255,107,26,0.05)]" data-id="element-48">
              <div className="text-hyrox-orange font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-49">
                El segundo lugar
              </div>
              <p className="text-white leading-relaxed font-medium" data-id="element-50">
                Llegás al lunes con la semana planificada, con la sesión
                estructurada y con las fichas de tus alumnos actualizadas. Tus
                alumnos progresan y lo ven. Vos sabés exactamente por qué. Y
                cuando alguien te pregunta el precio, lo decís sin dudar porque
                tenés el sistema que lo justifica.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-51">
          <div className="text-center" data-id="element-52">
            <p className="text-xl sm:text-2xl text-gray-300 mb-6" data-id="element-53">
              La diferencia entre esos dos lugares no es el talento. No es la
              experiencia. No es el esfuerzo.
            </p>
            <p className="text-4xl sm:text-6xl font-display font-black text-white uppercase tracking-tight" data-id="element-54">
              Es el sistema. <br data-id="element-55" />
              <span className="text-hyrox-orange" data-id="element-56">Y el sistema está acá.</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}